import type {Values} from '@wix/devzai-utils-common';

export const BymoPageSocialLinksIconType = {
    Default: 'Default',
    Stroke: 'Stroke',
} as const;

export type BymoPageSocialLinksIconType = Values<typeof BymoPageSocialLinksIconType>;
